import React, { useEffect } from 'react';
import Text, {
  TEXT_COLOR,
  TEXT_KIND,
  TEXT_FONT_WEIGHT,
  TEXT_SIZE,
  TEXT_DISPLAY,
} from '@/bit/components/components.text';
import { maskSeparation } from '@/utils/mask';
import FormTemplate from '@/components/formTemplate/index';
import InputController from '@/components/inputController';
import { PERSONAL_DATA } from '@/constants/personalData';

function ClientPersonalData({
  title = '',
  contactEmail = '',
  contactPhone = '',
  installationContactPhone = '',
  payment = '',
  edit = null,
  control = null,
  setValue = null,
  shouldHavePersonalData = true,
}) {
  const { CONTACT_PHONE, EMAIL } = PERSONAL_DATA;

  useEffect(() => {
    if (contactPhone && !contactEmail) {
      setValue(CONTACT_PHONE.ID, contactPhone);
    }
    if (contactEmail && !contactPhone) {
      setValue(EMAIL.ID, contactEmail);
    }
  }, [contactEmail, contactPhone]);

  return (
    <div className="client-personal-data">
      <FormTemplate
        titleText={title}
        action={
          edit
            ? {
                onClick: edit,
                label: 'Editar',
              }
            : null
        }
      >
        {shouldHavePersonalData &&
          (contactEmail && contactPhone ? (
            <>
              <div className="client-personal-data__text">
                <Text
                  text="Email:&nbsp;"
                  color={TEXT_COLOR.GREY6}
                  kind={TEXT_KIND.SPAN}
                  size={TEXT_SIZE.CAPTION2}
                  display={TEXT_DISPLAY.INLINE}
                  fontType={TEXT_FONT_WEIGHT.REGULAR}
                />
                <Text
                  text={contactEmail}
                  color={TEXT_COLOR.GREY5}
                  kind={TEXT_KIND.SPAN}
                  size={TEXT_SIZE.CAPTION2}
                  display={TEXT_DISPLAY.INLINE}
                  fontType={TEXT_FONT_WEIGHT.REGULAR}
                />
              </div>
              <div className="client-personal-data__text">
                <Text
                  text="Móvil:&nbsp;"
                  color={TEXT_COLOR.GREY6}
                  kind={TEXT_KIND.SPAN}
                  size={TEXT_SIZE.CAPTION2}
                  display={TEXT_DISPLAY.INLINE}
                  fontType={TEXT_FONT_WEIGHT.REGULAR}
                />
                <Text
                  text={maskSeparation(contactPhone, 9, 3, ' ')}
                  color={TEXT_COLOR.GREY5}
                  kind={TEXT_KIND.SPAN}
                  size={TEXT_SIZE.CAPTION2}
                  display={TEXT_DISPLAY.INLINE}
                  fontType={TEXT_FONT_WEIGHT.REGULAR}
                />
              </div>
            </>
          ) : (
            <>
              <InputController
                className="client-personal-data__input"
                inputName={EMAIL.NAME}
                inputId={EMAIL.ID}
                control={control}
                inputMode="email"
                rules={{
                  required: EMAIL.RULES.REQUIRED,
                  pattern: EMAIL.RULES.PATTERN.EMAIL_FORMAT,
                  validate: (fieldValue) =>
                    EMAIL.RULES.VALIDATE.EMAIL_DOMAIN.checkFunc(fieldValue) ||
                    EMAIL.RULES.VALIDATE.EMAIL_DOMAIN.message,
                }}
                label={EMAIL.LABEL}
              />

              <InputController
                className="client-personal-data__input--last"
                inputName={CONTACT_PHONE.NAME}
                inputId={CONTACT_PHONE.ID}
                mask={CONTACT_PHONE.MASK}
                control={control}
                inputMode="numeric"
                rules={{
                  required: CONTACT_PHONE.RULES.REQUIRED,
                  validate: (fieldValue) =>
                    CONTACT_PHONE.RULES.VALIDATE.CONTACT_PHONE_FORMAT.checkFunc(
                      fieldValue
                    ) ||
                    CONTACT_PHONE.RULES.VALIDATE.CONTACT_PHONE_FORMAT.message,
                }}
                label={CONTACT_PHONE.LABEL}
              />
            </>
          ))}

        {payment && (
          <div className="client-personal-data__text">
            <Text
              text="Forma de pago:&nbsp;"
              color={TEXT_COLOR.GREY6}
              kind={TEXT_KIND.SPAN}
              size={TEXT_SIZE.CAPTION2}
              display={TEXT_DISPLAY.INLINE}
              fontType={TEXT_FONT_WEIGHT.REGULAR}
            />
            <Text
              text={payment}
              color={TEXT_COLOR.GREY5}
              kind={TEXT_KIND.SPAN}
              size={TEXT_SIZE.CAPTION2}
              display={TEXT_DISPLAY.INLINE}
              fontType={TEXT_FONT_WEIGHT.REGULAR}
            />
          </div>
        )}
        {installationContactPhone && (
          <div className="client-personal-data__text">
            <Text
              text="Móvil de contacto para el instalador:&nbsp;"
              color={TEXT_COLOR.GREY6}
              kind={TEXT_KIND.SPAN}
              size={TEXT_SIZE.CAPTION2}
              display={TEXT_DISPLAY.INLINE}
              fontType={TEXT_FONT_WEIGHT.REGULAR}
            />
            <Text
              text={installationContactPhone}
              color={TEXT_COLOR.GREY5}
              kind={TEXT_KIND.SPAN}
              size={TEXT_SIZE.CAPTION2}
              display={TEXT_DISPLAY.INLINE}
              fontType={TEXT_FONT_WEIGHT.REGULAR}
            />
          </div>
        )}
      </FormTemplate>

      <style jsx>
        {`
          .client-personal-data {
            margin-bottom: 8px;
            .client-personal-data__text {
              margin-bottom: 4px;
            }
            :global(.client-personal-data__input) {
              margin: 0px 0 8px 0px;
              width: 100%;
            }
            :global(.client-personal-data__input--last) {
              margin: 0px 0 8px 0px;
              width: 100%;
            }
          }
        `}
      </style>
    </div>
  );
}

export default ClientPersonalData;
